var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43213 4.87332C4.92991 3.34932 7.26258 2.34443 8.43013 1.85865C11.7628 0.472653 12.4548 0.231986 12.9061 0.223986C13.0061 0.221986 13.2275 0.246653 13.3715 0.363986C13.4928 0.461986 13.5261 0.59532 13.5421 0.688653C13.5581 0.781986 13.5781 0.994653 13.5621 1.16065C13.3821 3.05865 12.6001 7.66332 12.2021 9.78865C12.0341 10.6873 11.7035 10.9887 11.3821 11.0187C10.6855 11.0827 10.1568 10.5587 9.48213 10.116C8.42547 9.42332 7.8288 8.99199 6.80347 8.31665C5.6188 7.53599 6.3868 7.10665 7.06213 6.40532C7.2388 6.22199 10.3088 3.42932 10.3688 3.17599C10.3755 3.14399 10.3828 3.02599 10.3128 2.96399C10.2428 2.90132 10.1395 2.92265 10.0641 2.93999C9.95791 2.96399 8.2708 4.0791 5.0028 6.28532C4.52324 6.61421 4.08947 6.77443 3.70147 6.76599C3.2728 6.75665 2.44813 6.52399 1.83613 6.32465C1.08413 6.07999 0.4868 5.95132 0.5388 5.53599C0.565911 5.31999 0.863689 5.0991 1.43213 4.87332Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.03e8dbe0773f860b6bcb4f283b7088a3.svg";
export { ForwardRef as ReactComponent };